import { urls } from '../settings';
import * as HttpJsonService from './http-json-service';
import routes from './routes';
import { types } from '../components/section/components/upload-new-ead';

export const postLogin = (data) => HttpJsonService.requestToken(data);

export const fetchUserData = () => HttpJsonService.getJson(urls.GET_USER_INFO);

export const fetchUserDataName = () => HttpJsonService.getJson(urls.GET_USER_INFO_NAME);

export const fetchUserDataFromCognito = () => HttpJsonService.getJson(urls.GET_USER_INFO_COGNITO);

export const fetchClass = (classId, params) => HttpJsonService.getJson(urls.CLASSES(classId), params);

export const fetchEnrollmentsList = () => HttpJsonService.getJson(urls.STUDENT_ENROLLMENTS);

export const fetchStudentEnrollment = (classId) => HttpJsonService.getJson(urls.STUDENT_ENROLLMENT(classId));

export const updateEnrollmentVideo = (classId, data) => HttpJsonService.patchJson(urls.ENROLLMENT_VIDEO(classId), data);

export const createEnrollmentVideo = (classId, data) => HttpJsonService.postJson(urls.ENROLLMENT_VIDEO(classId), data);

export const createEnrollmentActivity = (classId, data) => HttpJsonService.postJson(urls.ENROLLMENT_ACTIVITY(classId), data);

export const createTCC = (classId, data) => HttpJsonService.postJson(urls.ENROLLMENT_TCC(classId), data);

export const listClasses = () => HttpJsonService.getJson(urls.GET_CLASSES_NEW_EAD);

export const getClasse = (classId) => HttpJsonService.getJson(urls.GET_CLASSE_INFO(classId));

export const updateTccs = (classId, data) => HttpJsonService.postJson(urls.GET_CLASSE_INFO(classId), data);
export const submitTest = (classId) => HttpJsonService.postJson(urls.SUBMIT_TEST(classId));

export const initTestCall = (data) => HttpJsonService.postJson(urls.INIT_TEST_NEW_EAD, data);

export const downloadAttachment = ( classId, fileId) => HttpJsonService
    .getJson( urls.DOWNLOAD_ATTACH_POINT( classId, fileId ));

export const requestFileUpload = (data, { fileName = 'fileName', mime = 'image/jpeg' }) => HttpJsonService
    .putJson(urls.FILE_UPLOAD, data, { headers: { 'Content-Type': mime, 'x-scis-filename': fileName } });

export const withRetry = (fn) => async (...args) => {
    try {
        return await fn(...args);
    } catch (e) {
        if (e.response && e.response.status >= 500) {
            return await fn(...args);
        }
        throw e;
    }
};

export function goLogin() {
    const uri = encodeURIComponent(window.location.origin) + '/';
    window.location.replace(routes.LOGIN(uri));
}

export function goLogout() {
    const uri = encodeURIComponent(window.location.origin) + '/';
    window.location.replace(routes.LOGOUT(uri));
}

export function validSubmit(currentTcc = {}, tests = []) {
    const { coach_name, finish_first_module_date, finish_second_module_date, finish_master_date } = currentTcc;
    let isValid = true;
    if (tests.includes('UNIFICADO') || tests.includes('FORMACAO')) {
        if (currentTcc.attachments) {
            let attachmenstTypes = currentTcc.attachments.map(e=>e.type);
            if (!attachmenstTypes.includes(types.CYCLE_COACH.type) || !attachmenstTypes.includes(types.CYCLE_COACHEE.type)) {
                isValid = false;
            }
        } else {
            isValid = false;
        }
        if (!coach_name || !finish_first_module_date || !finish_second_module_date) {
            isValid = false;
        }
    }
    if (tests.includes('MASTER')) {
        if (currentTcc.attachments) {
            let attachmenstTypes = currentTcc.attachments.map(e=>e.type);
            if (!attachmenstTypes.includes(types.CYCLE_MASTER.type)) {
                isValid = false;
            }
        } else {
            isValid = false;
        }
        if (!finish_master_date) {
            isValid = false;
        }
    }
    return isValid;
}

export function returnValidTccAndTcc(currentTcc) {
    let validArray = currentTcc.attachments ? currentTcc.attachments : [];
    const validTcc = { ...currentTcc, attachments: [ ...validArray ] };
    delete validTcc.submitted;
    delete validTcc.submitted_at;
    return { currentTcc, validTcc };
}



// WEBPACK FOOTER //
// ./src/utils/common-functions.js